import DefaultKeywords from './DefaultKeywords'

export default DefaultKeywords